export default __webpack_public_path__ + "static/media/5.2e2e7a76.webp";